export const SITE_URL = "https://assurewealthonline.com";

export const GLOBAL_SEO_METADATA = {
  title: "โปรแกรมวางแผนการเงินออนไลน์ | เครื่องมือ CFP® | AssureWealth",
  description:
    "ใช้โปรแกรมวางแผนการเงินออนไลน์จากนักวางแผนการเงิน CFP® ครบวงจร ช่วยจัดการเกษียณ หนี้ ภาษี ประกัน และสร้างความสุขทางจิตใจ เริ่มต้นใช้งานฟรีวันนี้",
  image: `${SITE_URL}/images/logo_assure.png`,
  imageAlt: "Assure Wealth",
};

// title/description ของทั้ง 15 หน้ามาจาก SEO brief "assure-wealth-seo-title-description-final" (10 ส.ค. 2569)
// เกณฑ์ที่ brief กำหนดคือ title 50-60 ตัวอักษร และ description 130-160 ตัวอักษร
export const ROUTE_SEO_METADATA = {
  // หน้าหลัก — title 60 / description 144 ตัวอักษร
  "/": {
    title: "โปรแกรมวางแผนการเงินออนไลน์ | เครื่องมือ CFP® | AssureWealth",
    description:
      "ใช้โปรแกรมวางแผนการเงินออนไลน์จากนักวางแผนการเงิน CFP® ครบวงจร ช่วยจัดการเกษียณ หนี้ ภาษี ประกัน และสร้างความสุขทางจิตใจ เริ่มต้นใช้งานฟรีวันนี้",
  },
  // รู้จักเรา — title 55 / description 143 ตัวอักษร
  "/aboutus": {
    title: "เกี่ยวกับเรา | ทีมนักวางแผนการเงิน CFP® | Assure Wealth",
    description:
      "รู้จักทีม Assure Wealth ผู้พัฒนาโปรแกรมและเครื่องมือวางแผนการเงินออนไลน์ โดยนักวางแผนการเงิน CFP® ที่มุ่งสร้างความสุขและความสงบทางจิตใจให้คนไทย",
  },
  // ข้อมูลพรีเมียม — title 58 / description 147 ตัวอักษร
  "/infopremium": {
    title: "ข้อมูลพรีเมียม | รายงานเชิงลึกการเงิน | AssureWealthOnline",
    description:
      "เข้าถึงข้อมูลพรีเมียมและรายงานเชิงลึกด้านการวางแผนการเงิน พร้อมเครื่องมือวิเคราะห์สุขภาพการเงินอย่างละเอียดจากแพลตฟอร์ม AssureWealthOnline ได้ทันที",
  },
  // งบดุล — title 52 / description 144 ตัวอักษร
  "/balance": {
    title: "เครื่องมือวิเคราะห์งบดุลออนไลน์ | AssureWealthOnline",
    description:
      "ใช้เครื่องมือวิเคราะห์งบดุลส่วนบุคคลออนไลน์ ดูสินทรัพย์ หนี้สิน และความมั่งคั่งสุทธิอย่างชัดเจน เป็นจุดเริ่มต้นสำคัญของโปรแกรมวางแผนการเงินที่ดี",
  },
  // วางแผนเกษียณ — title 58 / description 138 ตัวอักษร
  "/retireplan": {
    title: "วางแผนเกษียณออนไลน์ | เครื่องมือ CFP® | AssureWealthOnline",
    description:
      "ใช้เครื่องมือวางแผนเกษียณออนไลน์ คำนวณเงินที่ต้องมีและอายุขัยอย่างแม่นยำ ด้วยมาตรฐานนักวางแผนการเงิน CFP® ช่วยให้เกษียณอย่างมั่นใจและสงบใจ",
  },
  // วางแผนภาษี — title 56 / description 137 ตัวอักษร
  "/taxplan": {
    title: "เครื่องมือวางแผนภาษีออนไลน์ | ประหยัดภาษี | AssureWealth",
    description:
      "ใช้เครื่องมือวางแผนภาษีออนไลน์ ช่วยลดหย่อนภาษีและวางแผนภาษีส่วนบุคคลอย่างชาญฉลาด เพื่อเพิ่มความมั่งคั่งด้วยแนวทางจากนักวางแผนการเงิน CFP®",
  },
  // วางแผนออม — title 50 / description 140 ตัวอักษร
  "/savingsplan": {
    title: "เครื่องมือวางแผนการออมออนไลน์ | AssureWealthOnline",
    description:
      "ใช้เครื่องมือวางแผนการออมออนไลน์ สร้างเงินสำรองฉุกเฉินและบรรลุเป้าหมายทางการเงินอย่างเป็นระบบ ด้วยมาตรฐานนักวางแผนการเงิน CFP® ที่ใช้งานง่าย",
  },
  // แผนจัดการหนี้สิน — title 54 / description 137 ตัวอักษร
  "/debtplan": {
    title: "เครื่องมือจัดการหนี้สินออนไลน์ | ลดหนี้ | AssureWealth",
    description:
      "ใช้เครื่องมือจัดการหนี้สินออนไลน์ วิเคราะห์และวางแผนชำระหนี้เพื่อลดภาระดอกเบี้ยอย่างมีประสิทธิภาพ ช่วยสร้างความสงบทางจิตใจได้อย่างยั่งยืน",
  },
  // แผนประกัน — title 58 / description 132 ตัวอักษร
  "/insuranceplan": {
    title: "แผนประกันออนไลน์ | คุ้มครองความเสี่ยง | AssureWealthOnline",
    description:
      "วางแผนประกันชีวิตและสุขภาพออนไลน์ วิเคราะห์ความต้องการอย่างเหมาะสม เพื่อปกป้องครอบครัวและทรัพย์สินด้วยแนวทางจากนักวางแผนการเงิน CFP®",
  },
  // แผนบริหารความเสี่ยง — title 50 / description 144 ตัวอักษร
  "/riskplan": {
    title: "แผนบริหารความเสี่ยงทางการเงิน | AssureWealthOnline",
    description:
      "บริหารความเสี่ยงทางการเงินออนไลน์ วิเคราะห์และวางแผนรับมือเหตุการณ์ไม่คาดฝันอย่างรอบด้าน เพื่อสร้างความมั่นคงระยะยาวให้กับชีวิตและครอบครัวของคุณ",
  },
  // แผนลงทุน — title 55 / description 138 ตัวอักษร
  "/investplan": {
    title: "แผนลงทุนออนไลน์ | ลงทุนตามเป้าหมาย | AssureWealthOnline",
    description:
      "วางแผนการลงทุนออนไลน์อย่างเป็นระบบ เลือกพอร์ตที่เหมาะสมกับความเสี่ยงและเป้าหมายชีวิตของคุณ ด้วยมาตรฐานนักวางแผนการเงิน CFP® ที่น่าเชื่อถือ",
  },
  // แผนมรดก — title 59 / description 131 ตัวอักษร
  "/legacyplan": {
    title: "วางแผนมรดกออนไลน์ | ส่งต่อความมั่งคั่ง | AssureWealthOnline",
    description:
      "วางแผนมรดกและพินัยกรรมออนไลน์ จัดสรรทรัพย์สินและลดภาษีมรดกอย่างรอบคอบ เพื่อส่งต่อความมั่นคงและความสงบใจให้คนที่คุณรักได้อย่างมั่นใจ",
  },
  // แผนการศึกษาบุตร — title 57 / description 130 ตัวอักษร
  "/education": {
    title: "วางแผนการศึกษาบุตรออนไลน์ | กองทุนการศึกษา | AssureWealth",
    description:
      "วางแผนค่าเล่าเรียนบุตรออนไลน์ คำนวณและออมเงินเพื่อการศึกษาในอนาคตอย่างเป็นระบบ ด้วยเครื่องมือที่ใช้งานง่ายจากนักวางแผนการเงิน CFP®",
  },
  // แผนอนาคต — title 52 / description 138 ตัวอักษร
  "/futureplan": {
    title: "แผนอนาคตออนไลน์ | เป้าหมายชีวิต | AssureWealthOnline",
    description:
      "วางแผนอนาคตและเป้าหมายชีวิตทางการเงินออนไลน์ ตั้งเป้าหมายระยะสั้นและระยะยาว พร้อมติดตามความคืบหน้าได้อย่างชัดเจน เป็นระบบ และมีประสิทธิภาพ",
  },
  // รายงานสรุป — title 57 / description 132 ตัวอักษร
  "/report": {
    title: "รายงานสรุปแผนการเงิน | สุขภาพการเงิน | AssureWealthOnline",
    description:
      "ดูรายงานสรุปแผนการเงินองค์รวมออนไลน์ วิเคราะห์สุขภาพการเงินของคุณในภาพรวม พร้อมคำแนะนำที่เป็นประโยชน์ตามมาตรฐานนักวางแผนการเงิน CFP®",
  },
};

// index ได้เฉพาะ route ที่ crawler เปิดเห็นเนื้อหาจริงโดยไม่ต้อง login
// route ที่เหลือใน ROUTE_SEO_METADATA อยู่หลัง ProtectedRoute ซึ่ง redirect ไป /login เมื่อไม่มี userData._id
// จึงยังได้ title/description ไว้ใช้ในแท็บเบราว์เซอร์ แต่ต้องเป็น noindex จนกว่าหน้าเหล่านั้นจะเปิดสาธารณะ
export const INDEXABLE_ROUTES = [
  "/",
  "/aboutus",
  "/infopremium",
  "/retireplan",
  "/taxplan",
  "/savingsplan",
];

// owner เดิมของหน้า indexable คงรูปแบบ map ไว้เพื่อให้ผู้เรียกเดิมและ sitemap ตรวจคู่กันได้
export const PUBLIC_ROUTE_METADATA = INDEXABLE_ROUTES.reduce(
  (accumulator, pathname) => ({
    ...accumulator,
    [pathname]: ROUTE_SEO_METADATA[pathname] || {},
  }),
  {}
);

// ปรับ trailing slash ให้ทุก route ใช้ key และ canonical รูปแบบเดียวกัน
const normalizePathname = (pathname) => {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.replace(/\/+$/, "") || "/";
};

// รวมค่า global กับ title/description ของ route แล้วตัดสิน index/noindex จาก owner กลางชุดเดียว
export const getSeoMetadata = (pathname) => {
  const normalizedPathname = normalizePathname(pathname);
  const isIndexable = INDEXABLE_ROUTES.includes(normalizedPathname);
  const routeMetadata = ROUTE_SEO_METADATA[normalizedPathname] || {};

  return {
    ...GLOBAL_SEO_METADATA,
    ...routeMetadata,
    canonicalUrl: isIndexable
      ? new URL(normalizedPathname, SITE_URL).toString()
      : null,
    isIndexable,
  };
};
